import { z } from "zod";

const id = z.string().min(1).max(500);

export const assistantAuthConfigReadInputSchema = z
  .object({ projectId: id })
  .strict();

const roleSchema = z.object({ id, name: z.string().max(1000) }).strict();

// Allowlisted projection: presence flags and counts only. Tokens, directory
// users/memberships, redirect URIs and arbitrary screen settings are never
// representable here, so strict parsing rejects any attempt to add them.
export const assistantAuthConfigSchema = z
  .object({
    provider: z.enum(["plasmic-auth", "custom-auth"]).nullable(),
    directoryConfigured: z.boolean(),
    redirectUriCount: z.number().int().min(0),
    authScreenConfigured: z.boolean(),
    userPropsConfigured: z.boolean(),
    registeredRole: roleSchema.nullable(),
  })
  .strict();

export const assistantAuthConfigErrorCodeSchema = z.enum([
  "ADAPTER_UNAVAILABLE",
  "AFFILIATION_MISMATCH",
  "SOURCE_CHANGED",
]);

export const assistantAuthConfigReadOutputSchema = z.union([
    z
      .object({
        status: z.literal("ok"),
        projectId: id,
        configured: z.literal(false),
        config: z.null(),
      })
      .strict(),
    z
      .object({
        status: z.literal("ok"),
        projectId: id,
        configured: z.literal(true),
        config: assistantAuthConfigSchema,
      })
      .strict(),
    z
      .object({
        status: z.literal("error"),
        projectId: id,
        code: assistantAuthConfigErrorCodeSchema,
        message: z.string().max(500),
      })
      .strict(),
]);

export type AssistantAuthConfigReadInput = z.infer<
  typeof assistantAuthConfigReadInputSchema
>;
export type AssistantAuthConfigReadOutput = z.infer<
  typeof assistantAuthConfigReadOutputSchema
>;
